import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import { dataDummy } from './data';
import {numeralFormat} from '../common/numeralFormat';

const ACTIONS_PLAYER = {
    GET_HEADER_PLAYER_PITCHERS_SUCCESS: 'GET_HEADER_PLAYER_PITCHERS_SUCCESS',
    GET_HEADER_PLAYER_PITCHERS_ERROR: 'GET_HEADER_PLAYER_PITCHERS_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const GetPlayerPitchers = () => {
    // const config = {
    //     method: 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
    //     },
    // };
    // let url = `${host.serverTest}api/players/${player_id}/basic/pitcher`;
    // return (dispatch) => {
    //     callApi(url, config,
    //         (data) => {
    //             dispatch(updateStatus(ACTIONS_PLAYER.GET_HEADER_PLAYER_PITCHERS_SUCCESS, data));
    //         },
    //         (err) => {
    //             dispatch(updateStatus(ACTIONS_PLAYER.GET_HEADER_PLAYER_PITCHERS_ERROR, err));
    //         });
    // };

    return (
        (dispatch) => {
            dispatch(updateStatus(ACTIONS_PLAYER.GET_HEADER_PLAYER_PITCHERS_SUCCESS, dataDummy.playerReportPitcher));
        }
    )
};

const converDataRecord = (list) => {
    if (list) {
        return list.map(it => {
            return {
                item: [
                    { text: it.record_name },
                    { text: it.remaining_achievement_cnt }
                ]
            }
        })
    }
}

const converTrouble = (list) => {
    if (list) {
        return list.map(it => {
            return {
                item: [
                    { text: it.batted_ball_name },
                    { text: it.cnt },
                    { text: `${it.ratio} %` }
                ]
            }
        })
    } else return null;
}

const convertDataPerformance = (list) => {
    if (list) {
        return list.map(it => {
            return {
                item: [
                    { text: it.pitchtype_name },
                    { text: `${it.pitch_rate} %` },
                    { text: it.batting_average && numeralFormat(it.batting_average, 3) },
                    { text: `${it.missed_swing_rate} %`},
                ]
            }
        })
    } else return null;
}

export {
    ACTIONS_PLAYER, GetPlayerPitchers, converDataRecord, convertDataPerformance,
    converTrouble
};